<template>
  <div>111323</div>
</template>
<script>

// (function (d, w, c) {
//     w.ChatraID = 'rkBRQaEyRfYPjnREK';
//     var s = d.createElement('script');
//     w[c] = w[c] || function () {
//       (w[c].q = w[c].q || []).push(arguments);
//     };
//     s.async = true;
//     s.src = 'https://call.chatra.io/chatra.js';
//     if (d.head) d.head.appendChild(s);
//   })(document, window, 'Chatra');

/**
 * Created by www.xingnuocn.com
 * @title：客服
 * @author: 刘嘉鑫 
 * @version  V1.0 
 * @datecreate: 2023-11-13 16:57
 */


// function initFreshChat() {
//   console.log(123123)
//   window.fcWidget.init({
//     token: "74c1108a-f2ad-4b88-a399-0db612f09ab7",
//     host: "https://wchat.freshchat.com"
//   });
// }
// function initialize(i, t) { var e; i.getElementById(t) ? initFreshChat() : ((e = i.createElement("script")).id = t, e.async = !0, e.src = "https://wchat.freshchat.com/js/widget.js", e.onload = initFreshChat, i.head.appendChild(e)) } function initiateCall() { initialize(document, "freshchat-js-sdk") } window.addEventListener ? window.addEventListener("load", initiateCall, !1) : window.attachEvent("load", initiateCall, !1);
export default {
  data() {
    return {};
  },
  mounted() {
    console.log(window)

    
    var Tawk_API = Tawk_API || {};
      Tawk_API.onLoad = function() {
        // Your Tawk.to onLoad logic, if needed
      };
      (function() {
        var s1 = document.createElement("script"),
          s0 = document.getElementsByTagName("script")[0];
        s1.async = true;
        s1.src = 'https://embed.tawk.to/65701605bfb79148e59a8676/1hgutc2lf';
        s1.charset = 'UTF-8';
        s1.setAttribute('crossorigin', '*');
        s0.parentNode.insertBefore(s1, s0);
      })();


      // var Tawk_API = {},
      //   Tawk_LoadStart = new Date(function () {
      //     var s1 = document.createElement('script'), sO = document.geElementsByTagName("script")[0];
      //     s1.async = true;
      //     s1.src = 'https://embed.tawk.to/65701605bfb79148e59a8676/1hqutc2lf';
      //     s1.charset = 'UTF-8';
      //     s1.setAttribute('crossorigin', '*')
      //     sO.parentNodeinsertBefore(s1.s0);
      //   })();

      // (function () {
      //   var s = d.createElement('script'); s.type = 'text/javascript'; s.async = true; s.src = 'https://embed.tawk.to/65701605bfb79148e59a8676/1hqutc2lf';
      //   // var w = window; var ic = w.Intercom; if (typeof ic === "function") { ic('reattach_activator'); ic('update', w.intercomSettings); } else { var d = document; var i = function () { i.c(arguments); }; i.q = []; i.c = function (args) { i.q.push(args); }; w.Intercom = i; var l = function () { var s = d.createElement('script'); s.type = 'text/javascript'; s.async = true; s.src = 'https://widget.intercom.io/widget/d8bopmds'; var x = d.getElementsByTagName('script')[0]; x.parentNode.insertBefore(s, x); }; if (document.readyState === 'complete') { l(); } else if (w.attachEvent) { w.attachEvent('onload', l); } else { w.addEventListener('load', l, false); } }
      // })();






    // var APP_ID = "d8bopmds";

    // window.intercomSettings = {
    //   api_base: "https://api-iam.intercom.io",
    //   app_id: APP_ID,
    //   // name: "<%= current_user.name %>", // Full name
    //   // email: "<%= current_user.email %>", // Email address
    //   // created_at: "<%= current_user.created_at.to_i %>" // Signup date as a Unix timestamp
    //   name: "Ajay Khan", // Full name
    //   email: "willamsongretchen35@gmail.com", // Email address
    //   created_at: "1312182000" // Signup date as a Unix timestamp
    // };

    // (function () {
    //   var w = window; var ic = w.Intercom; if (typeof ic === "function") { ic('reattach_activator'); ic('update', w.intercomSettings); } else { var d = document; var i = function () { i.c(arguments); }; i.q = []; i.c = function (args) { i.q.push(args); }; w.Intercom = i; var l = function () { var s = d.createElement('script'); s.type = 'text/javascript'; s.async = true; s.src = 'https://widget.intercom.io/widget/d8bopmds'; var x = d.getElementsByTagName('script')[0]; x.parentNode.insertBefore(s, x); }; if (document.readyState === 'complete') { l(); } else if (w.attachEvent) { w.attachEvent('onload', l); } else { w.addEventListener('load', l, false); } }
    // })();

    // console.log(window.intercomSettings)

    // window.Intercom('boot', {
    //   app_id: APP_ID,
    //   //Website visitor so may not have any user related info
    // });
    // window.fwSettings = {
    //   'widget_id': 1070000000768
    // };
    // // !function () { if ("function" != typeof window.FreshworksWidget) { var n = function () { n.q.push(arguments) }; n.q = [], window.FreshworksWidget = n } }()

    // console.log(window)

    //   (function () {
    //     var w = window;
    //     // var ic = w.fwSettings;
    //     // if (typeof ic === "function") {
    //     //   ic('reattach_activator');
    //     // } else {
    //     var d = document;
    //     var i = function () {
    //       i.c(arguments);
    //     };
    //     i.q = [];
    //     i.c = function (args) {
    //       i.q.push(args);
    //     };
    //     w.fwSettings = i;
    //     // var l = function () {
    //     var s = d.createElement('script');
    //     s.type = 'text/javascript';
    //     s.async = true;
    //     s.src = 'https://ind-widget.freshworks.com/widgets/1070000000768.js';
    //     var x = d.getElementsByTagName('script')[0];
    //     x.parentNode.insertBefore(s, x);
    //     // };
    //     // if (document.readyState === 'complete') {
    //     //   l();
    //     // } else if (w.attachEvent) {
    //     //   w.attachEvent('onload', l);
    //     // } else {
    //     //   w.addEventListener('load', l, false);
    //     // }
    //     // }
    //   })();

    // window.fcWidget.setExternalId("john.doe1987");

    // // To set user name
    // window.fcWidget.user.setFirstName("John");

    // // To set user email
    // window.fcWidget.user.setEmail("john.doe@gmail.com");

    // // To set user properties
    // // Note that any other fields passed as properties which are not in the CRM Contact properties already, they will be ignored.
    // window.fcWidget.user.setProperties({
    //   cf_plan: "Pro",                 // meta property 1
    //   cf_status: "Active"             // meta property 2
    // });




    // this.initFreshChat()
    // console.log(456)

  },
  methods: {

    initFreshChat() {
      console.log(123123)
      window.fcWidget.init({
        token: "74c1108a-f2ad-4b88-a399-0db612f09ab7",
        host: "https://wchat.freshchat.com"
      });
    }
  },
};
</script>

<!-- <script>
	
</script> -->
<!-- <script type='text/javascript' src='https://ind-widget.freshworks.com/widgets/1070000000768.js' async defer></script> -->

<style lang='scss' scoped></style>